/**
 * @generated SignedSource<<7a61a2af8f135bbaa18ba5c4aeb808f5>>
 * @relayHash 68dc2a54113080a1ce1d5fe5c0391a7a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c5164f5d18cdc9c4f547667dc3e4f7191c2f90b3db88dff6304aa2100153d157

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type OptInModalQuery$variables = {
  projectAri: string;
};
export type OptInModalQuery$data = {
  readonly project: {
    readonly associatedFieldConfigScheme?: {
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly associatedFieldScheme?: {
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly name?: string;
    readonly " $fragmentSpreads": FragmentRefs<"OptInModal" | "OptInModal_legacySchemes">;
  } | null | undefined;
};
export type OptInModalQuery = {
  response: OptInModalQuery$data;
  variables: OptInModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v5 = {
  "concreteType": "JiraFieldConfigScheme",
  "kind": "LinkedField",
  "name": "associatedFieldConfigScheme",
  "plural": false,
  "selections": (v4/*: any*/)
},
v6 = {
  "concreteType": "JiraFieldScheme",
  "kind": "LinkedField",
  "name": "associatedFieldScheme",
  "plural": false,
  "selections": (v4/*: any*/)
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v9 = [
  (v3/*: any*/),
  (v2/*: any*/),
  (v7/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v11 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v12 = [
  "input"
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "OptInModalQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "OptInModal_legacySchemes"
              },
              {
                "kind": "FragmentSpread",
                "name": "OptInModal"
              }
            ],
            "type": "JiraProject"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OptInModalQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "args": (v8/*: any*/),
                "concreteType": "JiraFieldConfigSchemesConnection",
                "kind": "LinkedField",
                "name": "availableFieldConfigSchemes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldConfigSchemesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldConfigScheme",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v9/*: any*/)
                      },
                      (v10/*: any*/)
                    ]
                  },
                  (v11/*: any*/)
                ],
                "storageKey": "availableFieldConfigSchemes(first:50)"
              },
              {
                "args": (v8/*: any*/),
                "filters": (v12/*: any*/),
                "handle": "connection",
                "key": "OptInModal_adminPagesFieldSchemes__availableFieldConfigSchemes",
                "kind": "LinkedHandle",
                "name": "availableFieldConfigSchemes"
              },
              {
                "args": (v8/*: any*/),
                "concreteType": "JiraFieldSchemesConnection",
                "kind": "LinkedField",
                "name": "availableFieldSchemes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldSchemesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldScheme",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v9/*: any*/)
                      },
                      (v10/*: any*/)
                    ]
                  },
                  (v11/*: any*/)
                ],
                "storageKey": "availableFieldSchemes(first:50)"
              },
              {
                "args": (v8/*: any*/),
                "filters": (v12/*: any*/),
                "handle": "connection",
                "key": "OptInModal_adminPagesFieldSchemes__availableFieldSchemes",
                "kind": "LinkedHandle",
                "name": "availableFieldSchemes"
              }
            ],
            "type": "JiraProject"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c5164f5d18cdc9c4f547667dc3e4f7191c2f90b3db88dff6304aa2100153d157",
    "metadata": {},
    "name": "OptInModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "74c9645058b91253e864b41c1a713270";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
